import {makeStyles} from '@material-ui/core/styles';
export default makeStyles((theme)=>({
    [theme.breakpoints.down('sm')]:{
        mainContainer:{
            flexDirection:"column-reverse"
        }
    },
    container:{
        marginTop:'30px'
    },
    forms:{
        alignContent:'center',
        marginTop:'200px',
        marginLeft:'300px',
        zIndex:4,
        opacity:2
    },
    modal2:{
        height:'100%',
        width: '100%',
        position: 'fixed',
        backgroundColor: 'gray',
        top: 0,
        left: 0,
        opacity: .9,
        zIndex: 10,
    },
    
    modalcontent:{
        backgroundColor: 'white',
        margin: '300px auto',
        height: '40%',
        width: '40%',
        textalign:'center'
    },
    Wrapper:{
        position:'relative',
        zIndex: 0,
    },
   
 
}))

